
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M3.5,18.75H2a1.5,1.5,0,0,1-1.5-1.5V6.75A1.5,1.5,0,0,1,2,5.25H17a1.5,1.5,0,0,1,1.5,1.5v3","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M18,5.65,15.2,1.42A1.5,1.5,0,0,0,14,.75H5.05a1.5,1.5,0,0,0-1.25.67L1,5.65","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"9.5","y1":"0.75","x2":"9.5","y2":"5.25","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('g',[_c('path',{attrs:{"d":"M8.79,21.75H8a1.5,1.5,0,0,1-1.5-1.5v-6A1.5,1.5,0,0,1,8,12.75h8a1.5,1.5,0,0,1,1.5,1.5v5.47","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M17.5,14.25h3a3,3,0,0,1,3,3v3a1.5,1.5,0,0,1-1.5,1.5H20.21","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('circle',{attrs:{"cx":"18.37","cy":"21.37","r":"1.87","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('circle',{attrs:{"cx":"10.62","cy":"21.37","r":"1.87","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"16.54","y1":"21.75","x2":"12.46","y2":"21.75","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])])])
          )
        }
      }
    